import styled, { css } from 'styled-components';
import {
  Input as InputRaw,
  Select as SelectRaw,
} from '@sparebankenvest/splash-ui';

const labelStyle = css`
  font-weight: 700;
  font-size: 16px;
  margin-right: -100px;
  width: 280px;
  margin-bottom: 4px;
  margin-top: 12px;
  color: #444;
  display: flex;
`;
const inputStyle = css`
  width: 180px;
  label {
    ${labelStyle}
  }
`;

const Input = styled(InputRaw)`
  ${inputStyle}
`;

const Select = styled(SelectRaw)`
  ${inputStyle}
`;

export {
  Input,
  Select,
  labelStyle,
};